import type { Breakpoint } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

export type ResponsiveQuery = 'up' | 'down' | 'between' | 'only';

/**
 * `end` is only consulted for the 'between' query; the other queries ignore it.
 * All four media queries are evaluated unconditionally to satisfy the rules of hooks.
 */
export default function useResponsive(query: ResponsiveQuery, start: Breakpoint, end?: Breakpoint): boolean {
    const theme = useTheme();

    const mediaUp = useMediaQuery(theme.breakpoints.up(start));

    const mediaDown = useMediaQuery(theme.breakpoints.down(start));

    const mediaBetween = useMediaQuery(theme.breakpoints.between(start, end ?? start));

    const mediaOnly = useMediaQuery(theme.breakpoints.only(start));

    if (query === 'up') {
        return mediaUp;
    }

    if (query === 'down') {
        return mediaDown;
    }

    if (query === 'between') {
        return mediaBetween;
    }

    return mediaOnly;
}
